<div class="loading-container">
    <span #spinner class="loading-spinner spinner-border text-primary" role="status"></span>
    <span class="loading-text"><ng-content></ng-content></span>
</div>
